import React, { useEffect, useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { Link, useHistory, withRouter } from "react-router-dom";
import { isEmpty } from "lodash";
import * as moment from "moment";
import { InputGroup, InputGroupText, Spinner, Tooltip } from "reactstrap";
import axios from "axios";
// Import Images
import dummyImg from "../../../assets/images/users/user-dummy-img.jpg";

import {
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  ModalFooter,
  Table,
  FormFeedback,
  Button,
} from "reactstrap";
import Select from "react-select";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

//Import actions
import { getFactures as onGetFactures } from "../../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import TableContainer from "../../../Components/Common/TableContainer";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import Loader from "../../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReducer } from "react";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../axiosConfig";
import TooltipComponent from "../../../Components/Common/TooltipComponent";

const TypeEngin = (props) => {
  function formatDate(date) {
    const dateObject = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    });
    return dateObject;
  }

  const history = useHistory();
  const [formData1, setFormData1] = useState({});
  const dispatch = useDispatch();
  const token = JSON.parse(localStorage.getItem("authUser"))
    ? JSON.parse(localStorage.getItem("authUser")).accessToken
    : null;

  const [typeEngin, setTypeEngin] = useState([]);

  const [loading, setLoading] = useState(true);

  const fetchDataTypeEngin = async () => {
    try {
      const gettypeengin = await axiosInstance.get(`/gettypeengin/`);
      if (gettypeengin?.data) {
        setTypeEngin(gettypeengin.data.data);
      }
    } catch (err) {
      console.log("erreur récupération des types engin", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDataTypeEngin();
  }, []);
  const [loadingSuspension, setLoadingSuspension] = useState(false);
  const [modalConfirmSuspension, setModalConfirmSuspension] = useState(false);
  const [factureGenerate, setFactureGenerate] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [columnTypeEnginSelected, setColumnTypeEnginSelected] = useState({});

  //delete Conatct
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalMotif, setModalMotif] = useState(false);

  const handleClickViewMotif = (etat, motifs) => {
    if (etat === "Desactiver" && motifs != null) {
      alert(motifs);
    }
  };

  // Add Data
  const handleTypeEnginClicks = () => {
    setColumnTypeEnginSelected({});
    setIsEdit(false);
    // toggle();
  };

  // Update Data
  const handleTypeEnginClick = useCallback((arg) => {
    // console.log("handleTypeEnginClick: ", arg);
    setColumnTypeEnginSelected(arg);

    // toggle();
  }, []);

  const handleActiveTypeEngin = useCallback((status, idTypeEngin) => {
    setLoadingSuspension(true);
    axiosInstance
      .put(`/statuttypeengin/?id=${idTypeEngin}`, {
        status: status,
      })
      .then((res) => {
        // console.log(res);
        toast.success(res.data.message);
        setLoadingSuspension(false);
        setModalConfirmSuspension(false);
        // dispatch( onGetCodePromos() );
        fetchDataTypeEngin();
      })
      .catch((err) => {
        console.error(err);
        toast.error("Erreur lors changement de status au type engin.");
        setLoadingSuspension(false);
      });
  }, []);

  // Column
  const columns = useMemo(
    () => [
      {
        Header: props.t("Désignation"),
        accessor: "designation",
        filterable: false,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          const value = data.designation;
          return (
            // https://takci.inawo.pro/type_engin/

            <div className={`row row-cols-md-2 g-1`}>
              {data.small_img && (
                <img
                  src={`${process.env.REACT_APP_API_URL}/type_engin/${data.small_img}`}
                  alt="icon"
                  style={{
                    maxWidth: "50%",
                    maxHeight: "50px",
                  }}
                />
              )}

              {value}
            </div>
          );
        },
      },
      {
        Header: props.t("Classe"),
        accessor: "classe",
        filterable: false,
      },
      {
        Header: props.t("Prise en charge"),
        accessor: "prise_en_charge",
        filterable: false,
        Cell: ({ value }) => `${value} FCFA`,
      },
      {
        Header: props.t("Coût distance"),
        accessor: "cout_distance",
        filterable: false,
        Cell: ({ value }) => `${value} FCFA/km`,
      },
      {
        Header: props.t("Coût durée"),
        accessor: "cout_duree",
        filterable: false,
        Cell: ({ value }) => `${value} FCFA/h`,
      },
      {
        Header: props.t("Climatisation"),
        accessor: "climatisation",
        filterable: false,
        Cell: ({ value }) => (
          <span
            className={`badge badge-soft-${value ? "success" : "secondary"}`}
          >
            {value ? "Oui" : "Non"}
          </span>
        ),
      },
      {
        Header: props.t("Statut"),
        accessor: "statut",
        filterable: true,
        Cell: (cell) => (
          <>
            {cell.row.original.statut ? (
              <span className="badge badge-soft-success me-1">Activé</span>
            ) : (
              <span className="badge badge-soft-danger me-1">Desactivé</span>
            )}
          </>
        ),
      },
      {
        Header: props.t("Actions"),
        Cell: (cellProps) => {
          const typeEnginData = cellProps.row.original;
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item" title={props.t("Modifier")}>
                <Link
                  to={`#!`}
                  className="text-primary d-inline-block"
                  onClick={(e) => {
                    e.preventDefault();
                    handleTypeEnginClick(typeEnginData);
                    setIsEdit(true);
                    setModal(true);
                  }}
                >
                  <i className="ri-pencil-fill fs-16"></i>
                </Link>
              </li>

              {cellProps.row.original.statut ? (
                <li className="list-inline-item" title={props.t("Suspendre")}>
                  <Link
                    to="#"
                    className="btn btn-sm btn-soft-danger d-inline-block"
                    onClick={(e) => {
                      e.preventDefault();
                      handleTypeEnginClick(typeEnginData);
                      setModalConfirmSuspension(true);
                    }}
                  >
                    <i className="ri-pause-line fs-16"></i>
                  </Link>
                </li>
              ) : (
                <li className="list-inline-item" title={props.t("Activer")}>
                  <Link
                    to="#"
                    className="btn btn-sm btn-soft-success d-inline-block"
                    onClick={(e) => {
                      e.preventDefault();
                      handleActiveTypeEngin(true, typeEnginData.id);
                    }}
                  >
                    <i className="ri-check-line fs-16"></i>
                  </Link>
                </li>
              )}
            </ul>
          );
        },
      },
    ],
    [handleTypeEnginClick, handleActiveTypeEngin, props]
  );

  const SUPPORTED_FORMATS = ["image/*"];
  // validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      designation: columnTypeEnginSelected?.designation || "",
      classe: columnTypeEnginSelected?.classe || "",
      prise_en_charge: columnTypeEnginSelected?.prise_en_charge || 0,
      cout_distance: columnTypeEnginSelected?.cout_distance || 0,
      cout_duree: columnTypeEnginSelected?.cout_duree || 0,
      climatisation: columnTypeEnginSelected?.climatisation || false,
      img: null,
      small_img: null,
      // Prévisualisations
      imgPreview: columnTypeEnginSelected?.img || null,
      smallImgPreview: columnTypeEnginSelected?.small_img || null,
      id: columnTypeEnginSelected?.id || "",
    },
    validationSchema: Yup.object({
      designation: Yup.string().required("La désignation est obligatoire"),
      classe: Yup.string(),
      prise_en_charge: Yup.number().required(
        "Le coût de prise en charge est obligatoire"
      ),
      cout_distance: Yup.number().required(
        "Le coût par distance est obligatoire"
      ),
      cout_duree: Yup.number().required("Le coût par durée est obligatoire"),
      climatisation: Yup.boolean().required(
        "La climatisation doit être spécifiée"
      ),
      img: isEdit
        ? Yup.mixed()
        : Yup.mixed().required("L'image principale est requise"),
      small_img: isEdit
        ? Yup.mixed()
        : Yup.mixed().required("La miniature est requise"),
      id: isEdit ? Yup.string().required("L'ID est requis") : Yup.string(),
    }),
    onSubmit: async (values) => {
      try {
        const formData = new FormData();

        // Ajout des champs texte
        formData.append("designation", values.designation);
        formData.append("classe", values.classe);
        formData.append("prise_en_charge", values.prise_en_charge);
        formData.append("cout_distance", values.cout_distance);
        formData.append("cout_duree", values.cout_duree);
        formData.append("climatisation", values.climatisation);

        // Ajout des fichiers si nouveaux
        if (values.img) formData.append("img", values.img);
        if (values.small_img) formData.append("small_img", values.small_img);

        const url = isEdit ? `/engin/?id=${values.id}` : "/engin";

        const method = isEdit ? "put" : "post";
        console.log("url: ", url);
        console.log("method: ", method);

        const response = await axiosInstance[method](url, formData);

        toast.success(
          isEdit
            ? "Type d'engin mis à jour avec succès"
            : "Type d'engin créé avec succès",
          { autoClose: 3000 }
        );

        fetchDataTypeEngin();
        setModal(false);
        setIsEdit(false);
        setColumnTypeEnginSelected();
        validation.resetForm();
      } catch (error) {
        toast.error(
          isEdit ? "Échec de la mise à jour" : "Échec de la création",
          { autoClose: 3000 }
        );
        console.error(error);
      }
    },
  });
  // SideBar Facture Detail

  document.title = props.t("Gestionnaire des types d'engin | Takci");
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={props.t("Gestionnaire des types d'engin")}
            pageTitle="Takci"
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <div className="d-flex justify-content-end">
                    <div className="flex-shrink-0">
                      <button
                        disabled={loading}
                        type="button"
                        className="btn btn-primary"
                        onClick={() => setModal(true)}
                      >
                        <i className="ri-add-line align-bottom me-1"></i>{" "}
                        {props.t("Ajouter un type engin")}
                      </button>

                      {typeEngin && typeEngin.length > 0 && (
                        <button
                          disabled={!typeEngin && typeEngin.length < 0}
                          type="button"
                          className="btn"
                          style={{ color: "#eac22f" }}
                          onClick={() => setIsExportCSV(true)}
                        >
                          <i className="ri-file-download-line align-bottom me-1"></i>{" "}
                          {props.t("Export")}
                        </button>
                      )}
                    </div>
                  </div>
                </CardHeader>
              </Card>
            </Col>
            <Col xxl={12}>
              <Card id="typeEnginList">
                <CardBody className="pt-0">
                  <div>
                    {!loading ? (
                      typeEngin && typeEngin.length > 0 ? (
                        <>
                          <ExportCSVModal
                            show={isExportCSV}
                            onCloseClick={() => setIsExportCSV(false)}
                            data={
                              typeEngin && typeEngin.length > 0 ? typeEngin : []
                            }
                          />

                          <TableContainer
                            columns={columns}
                            data={
                              typeEngin && typeEngin.length > 0 ? typeEngin : []
                            }
                            isGlobalFilter={true}
                            isAddUserList={false}
                            customPageSize={8}
                            className="custom-header-css"
                            divClass="table-responsive table-card mb-3"
                            tableClass="align-middle table-nowrap"
                            theadClass="table-light"
                            handleTypeEnginClick={handleTypeEnginClicks}
                          />
                        </>
                      ) : (
                        <h2 className="text-center my-3">
                          Aucun type d'engin disponible
                        </h2>
                      )
                    ) : (
                      <div className="text-center my-3">
                        <Loader style={{ color: "#014c94" }} />
                        <h2>Chargement...</h2>
                      </div>
                    )}
                  </div>
                  <Modal
                    id="typeEnginModal"
                    style={{ maxWidth: 800 }}
                    isOpen={modal}
                    centered
                  >
                    <ModalHeader className="bg-soft-info p-3">
                      {isEdit
                        ? props.t("Modifier Type d'Engin")
                        : props.t("Ajouter Type d'Engin")}
                    </ModalHeader>

                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <ModalBody>
                        <Input
                          type="hidden"
                          id="id-field"
                          value={validation.values.id || ""}
                        />
                        <Row className="g-3 mb-3">
                          {/* Désignation */}
                          <Col md={6}>
                            <div>
                              <Label
                                htmlFor="designation"
                                className="form-label"
                              >
                                {props.t("Désignation")}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <Input
                                name="designation"
                                id="designation"
                                className="form-control"
                                placeholder={props.t("Ex: Camion")}
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.designation || ""}
                                invalid={
                                  validation.touched.designation &&
                                  validation.errors.designation
                                }
                              />
                              <FormFeedback>
                                {validation.touched.designation &&
                                  validation.errors.designation}
                              </FormFeedback>
                            </div>
                          </Col>

                          {/* Classe */}
                          <Col md={6}>
                            <div>
                              <Label htmlFor="classe" className="form-label">
                                {props.t("Classe")}{" "}
                              </Label>
                              <Input
                                name="classe"
                                id="classe"
                                className="form-control"
                                placeholder={props.t("Ex: benne")}
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.classe || ""}
                                invalid={
                                  validation.touched.classe &&
                                  validation.errors.classe
                                }
                              />
                              <FormFeedback>
                                {validation.touched.classe &&
                                  validation.errors.classe}
                              </FormFeedback>
                            </div>
                          </Col>

                          {/* Champs supplémentaires seulement en mode création */}
                          {/* Prise en charge */}
                          <Col md={6}>
                            <div>
                              <Label
                                htmlFor="prise_en_charge"
                                className="form-label"
                              >
                                {props.t("Coût prise en charge")}
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <InputGroup>
                                <Input
                                  name="prise_en_charge"
                                  id="prise_en_charge"
                                  className="form-control"
                                  type="number"
                                  step="0.01"
                                  min="0"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={
                                    validation.values.prise_en_charge || ""
                                  }
                                  invalid={
                                    validation.touched.prise_en_charge &&
                                    validation.errors.prise_en_charge
                                  }
                                />
                                <InputGroupText>FCFA</InputGroupText>
                              </InputGroup>
                              <FormFeedback>
                                {validation.touched.prise_en_charge &&
                                  validation.errors.prise_en_charge}
                              </FormFeedback>
                            </div>
                          </Col>

                          {/* Coût distance */}
                          <Col md={6}>
                            <div>
                              <Label
                                htmlFor="cout_distance"
                                className="form-label"
                              >
                                {props.t("Coût par km")}
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <InputGroup>
                                <Input
                                  name="cout_distance"
                                  id="cout_distance"
                                  className="form-control"
                                  type="number"
                                  step="0.01"
                                  min="0"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.cout_distance || ""}
                                  invalid={
                                    validation.touched.cout_distance &&
                                    validation.errors.cout_distance
                                  }
                                />
                                <InputGroupText>FCFA/km</InputGroupText>
                              </InputGroup>
                              <FormFeedback>
                                {validation.touched.cout_distance &&
                                  validation.errors.cout_distance}
                              </FormFeedback>
                            </div>
                          </Col>

                          {/* Coût durée */}
                          <Col md={6}>
                            <div>
                              <Label
                                htmlFor="cout_duree"
                                className="form-label"
                              >
                                {props.t("Coût par heure")}
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <InputGroup>
                                <Input
                                  name="cout_duree"
                                  id="cout_duree"
                                  className="form-control"
                                  type="number"
                                  step="0.01"
                                  min="0"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.cout_duree || ""}
                                  invalid={
                                    validation.touched.cout_duree &&
                                    validation.errors.cout_duree
                                  }
                                />
                                <InputGroupText>FCFA/h</InputGroupText>
                              </InputGroup>
                              <FormFeedback>
                                {validation.touched.cout_duree &&
                                  validation.errors.cout_duree}
                              </FormFeedback>
                            </div>
                          </Col>

                          {/* Climatisation */}
                          <Col md={6}>
                            <div>
                              <Label
                                htmlFor="climatisation"
                                className="form-label"
                              >
                                {props.t("Climatisation")}
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <Input
                                name="climatisation"
                                id="climatisation"
                                className="form-control"
                                type="select"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={
                                  validation.values.climatisation
                                    ? "true"
                                    : "false"
                                }
                                invalid={
                                  validation.touched.climatisation &&
                                  validation.errors.climatisation
                                }
                              >
                                <option value="true">{props.t("Oui")}</option>
                                <option value="false">{props.t("Non")}</option>
                              </Input>
                              <FormFeedback>
                                {validation.touched.climatisation &&
                                  validation.errors.climatisation}
                              </FormFeedback>
                            </div>
                          </Col>

                          {/* ID visible seulement en mode édition */}
                          {isEdit && (
                            <Col md={6}>
                              <div>
                                <Label htmlFor="id" className="form-label">
                                  {props.t("ID")}
                                </Label>
                                <Input
                                  name="id"
                                  id="id"
                                  className="form-control"
                                  type="text"
                                  disabled
                                  value={validation.values.id || ""}
                                />
                              </div>
                            </Col>
                          )}
                        </Row>

                        {!isEdit && (
                          <Row className="mb-3 g-3">
                            <Col md={6}>
                              <Label>
                                Image principale
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <Input
                                type="file"
                                name="img"
                                accept="image/*"
                                onChange={(e) => {
                                  const file = e.target.files[0];
                                  validation.setFieldValue("img", file);
                                  validation.setFieldValue(
                                    "imgPreview",
                                    file ? URL.createObjectURL(file) : null
                                  );
                                }}
                              />
                              {validation.errors.img && (
                                <div className="text-danger">
                                  {validation.errors.img}
                                </div>
                              )}
                              {validation.values.imgPreview && (
                                <div className="mt-2">
                                  <img
                                    src={validation.values.imgPreview}
                                    alt="Preview"
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "150px",
                                    }}
                                  />
                                </div>
                              )}
                            </Col>

                            <Col md={6}>
                              <Label>
                                Miniature
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <Input
                                type="file"
                                accept="image/*"
                                name="small_img"
                                onChange={(e) => {
                                  const file = e.target.files[0];
                                  validation.setFieldValue("small_img", file);
                                  validation.setFieldValue(
                                    "smallImgPreview",
                                    file ? URL.createObjectURL(file) : null
                                  );
                                }}
                              />
                              {validation.errors.small_img && (
                                <div className="text-danger">
                                  {validation.errors.small_img}
                                </div>
                              )}
                              {validation.values.smallImgPreview && (
                                <div className="mt-2">
                                  <img
                                    src={validation.values.smallImgPreview}
                                    alt="Preview miniature"
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "150px",
                                    }}
                                  />
                                </div>
                              )}
                            </Col>
                          </Row>
                        )}
                      </ModalBody>
                      <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                          <Button
                            type="button"
                            onClick={() => {
                              setModal(false);
                              setColumnTypeEnginSelected({});
                              validation.resetForm();
                            }}
                            className="btn-light"
                          >
                            {props.t("Fermer")}
                          </Button>

                          <Button type="submit" color="primary" id="save-btn">
                            {isEdit
                              ? props.t("Enregistrer")
                              : props.t("Ajouter")}
                          </Button>
                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>

                  <Modal
                    id="showModalConfirmDelete"
                    style={{ maxWidth: 800 }}
                    isOpen={modalConfirmSuspension}
                    centered
                  >
                    <ModalBody className="py-3 px-5">
                      <div className="mt-2 text-center">
                        <lord-icon
                          src="https://cdn.lordicon.com/gsqxdxog.json"
                          trigger="loop"
                          colors="primary:#014c94,secondary:#eac22f"
                          style={{
                            width: "100px",
                            height: "100px",
                          }}
                        ></lord-icon>
                        <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                          <h4>Êtes-vous sûr ?</h4>
                          <p className="text-muted mx-4 mb-0">
                            Êtes-vous sûr de vouloir suspendre ce type d'engin ?
                          </p>
                        </div>
                      </div>
                      <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                        <button
                          disabled={loadingSuspension}
                          type="button"
                          className="btn w-sm btn-light"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setModalConfirmSuspension(false);
                          }}
                        >
                          Fermer
                        </button>
                        <button
                          disabled={loadingSuspension}
                          type="button"
                          className="btn w-sm btn-danger"
                          id="suspension-type-engin"
                          onClick={() =>
                            handleActiveTypeEngin(
                              false,
                              columnTypeEnginSelected.id
                            )
                          }
                        >
                          {loadingSuspension ? (
                            <div className="d-flex align-items-center text-center">
                              <Spinner size={"sm"} style={{ color: "#fff" }} />
                              <span className="ms-1">Suspension...</span>
                            </div>
                          ) : (
                            <span> Oui, suspendez-le !</span>
                          )}
                        </button>
                      </div>
                    </ModalBody>
                  </Modal>
                  <ToastContainer closeButton={false} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

TypeEngin.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(TypeEngin));
